/**
 * O que a tela de comentários (ORD-F-026) faz igual no site ao vivo e no replay: o lugar de um fio como rota ("Ver no
 * mapa") e a volta à Apuração (a região viva diz o nome da tela uma vez; o foco que estava na tela que saiu vai ao botão
 * "Apuração" da troca).
 */
import { useEffect, useRef } from 'preact/hooks';
import { announce } from '../a11y/LiveRegion';
import { tScreen } from '../copy/screen';
import type { TimelineThread } from '../features/commentary/timelineModel';
import type { PlaceRoute } from '../model/types';
import { ufFromIbge } from '../router/slugs';

/** O lugar do comentário como rota: Brasil, UF ou município (a cidade do exterior abre o Exterior). */
export function placeRouteOf(t: TimelineThread): PlaceRoute {
  const { placeLevel, placeCode } = t.item;
  if (placeLevel === 'BR' || placeCode === null) return { kind: 'br' };
  if (placeLevel === 'UF') return { kind: 'uf', uf: placeCode as Extract<PlaceRoute, { kind: 'uf' }>['uf'] };
  const uf = /^\d{7}$/.test(placeCode) ? ufFromIbge(placeCode) : null;
  return uf ? { kind: 'municipality', uf, ibge: placeCode, zone: null } : { kind: 'abroad' };
}

/** Ao fechar a tela (troca, Esc ou Voltar): anúncio e foco. `on` = a tela está aberta. */
export function useScreenReturn(on: boolean): void {
  const was = useRef(on);
  useEffect(() => {
    if (was.current === on) return;
    was.current = on;
    if (on) return;
    announce(tScreen('timeline.toggle.results'), 'response');
    const active = document.activeElement;
    if (active === null || active === document.body) {
      document.querySelector<HTMLElement>('[data-testid="screen-toggle"] [aria-pressed="true"]')?.focus();
    }
  }, [on]);
}
